export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.a2811307.worker.js");
}
